import React from 'react';
import SEO from '../components/SEO';

export default function AntiBriberyPage() {
  return (
    <div data-testid="anti-bribery-page">
      <SEO
        title="Anti-Bribery Policy"
        description="Glossop & District Round Table 916's zero-tolerance approach to bribery and corrupt activities."
        path="/policies/anti-bribery"
        keywords={['anti-bribery policy', 'bribery act 2010', 'Glossop Round Table policy']}
      />

      <div className="pt-28 sm:pt-32 pb-20 sm:pb-28 bg-white min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Ethics & Compliance</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] mb-8">
            Anti-Bribery Policy
          </h1>
          <p className="text-base text-[#52525B] leading-relaxed mb-6 italic">
            Zero tolerance for bribery and corrupt activities
          </p>

          <div className="space-y-8 text-base text-[#52525B] leading-relaxed">
            <div>
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-3">Policy Statement</h3>
              <p className="mb-4">
                Glossop & District Round Table 916 has a zero tolerance for bribery and corrupt activities. As an organisation, we are committed to acting professionally, fairly and with integrity in all our dealings and relationships.
              </p>
              <p className="mb-4">
                Bribery is the practice of offering or receiving an incentive to gain a reward or advantage. A bribe can take various forms including cash, gifts, hospitality, a contract award, or gaining inside information about upcoming work.
              </p>
              <p>
                Under the UK Bribery Act 2010, it is illegal to offer, agree to offer, accept, agree to accept, request a bribe, bribe a foreign public official, or fail to prevent bribery in a commercial organisation.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Policy Responsibility</h2>
              <p className="mb-4">
                Our Chairman has overall accountability for managing the risk of bribery, ensuring this policy complies with our legal obligations, and that all those under our control comply with it.
              </p>
              <p>
                Individuals should not offer, make, ask for, accept a payment, gift or favour in return for favourable treatment, or to gain an advantage.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Gifts, Hospitality and Expenses</h2>
              <p className="mb-4">
                We accept normal and appropriate gestures of hospitality and goodwill, so long as the giving or receiving of gifts meets the following requirements:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>It is not made with the intention of influencing the party to whom it is being given</li>
                <li>It is not made with the suggestion that a return favour is expected</li>
                <li>It is compliant with local law</li>
                <li>It is given in the name of the organisation, not in an individual's name</li>
                <li>It is appropriate for the circumstances (e.g., small gift at Christmas)</li>
                <li>It is given or received openly and not secretly</li>
                <li>It is not selectively given to a key, influential person with the intention of directly influencing them</li>
                <li>It is not above a certain excessive value, as predetermined by the Compliance Officer</li>
                <li>It is not offered to or accepted from a government official without prior approval</li>
              </ul>
              <p className="mt-4">
                Where it is inappropriate to decline the offer of a gift, the gift may be accepted if it is declared to the Compliance Officer who will assess the circumstances. As good practice, gifts given and received should always be disclosed to the Compliance Officer.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Facilitating Payments and Kickbacks</h2>
              <p>
                We will not accept facilitation payments or kickbacks of any kind. Facilitation payments are typically small, unofficial payments offered to secure or expedite an action. All individuals must avoid any activity that might lead to a facilitation payment or kickback.
              </p>
            </div>

            <div className="p-6 bg-[#F4F4F5] border-l-4 border-[#F0A500]">
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Reporting a Bribe</h3>
              <p className="mb-3">
                The prevention, detection and reporting of bribery is everyone's responsibility. If you have been offered a bribe or received an inappropriate request:
              </p>
              <ol className="list-decimal pl-6 space-y-2">
                <li>Do not accept the bribe and decline the request</li>
                <li>Inform the Chairman that you think you may have been offered a bribe</li>
                <li>Report the incident to{' '}
                  <a href="mailto:info@glossoproundtable.org" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">
                    info@glossoproundtable.org
                  </a>
                </li>
              </ol>
            </div>

            <div>
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-3">Bribery Breaches</h3>
              <p>
                Bribery is a criminal offence under the UK Bribery Act 2010. Any individual who breaches this policy will face appropriate action. A breach of this legislation is likely to result in criminal proceedings and possible imprisonment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
